import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

const HandoffNotes = observer(({ handoffNotes, setHandoffNotesCallback }) => (
  <section className="ransom-section">
    <p>
      <strong>Handoff Notes</strong>
    </p>
    <textarea
      value={handoffNotes}
      onChange={event => setHandoffNotesCallback(event.target.value)}
      placeholder="Notes entered here will be sent in an email notifying that this job is ready"
    />
  </section>
));

HandoffNotes.propTypes = {
  handoffNotes: PropTypes.string,
  setHandoffNotesCallback: PropTypes.func.isRequired,
};

export default HandoffNotes;
